import claudeAgentPaperLogo from '@/assets/claude-agent-paper.webp'
import xaiLogo from '@/assets/xai-logo.ico'
import openrouterLogo from '@/assets/openrouter-logo.ico'
import groqLogo from '@/assets/groq-logo.ico'
import mistralLogo from '@/assets/mistral-logo.ico'
import kimiLogo from '@/assets/kimi-logo.ico'
import minimaxLogo from '@/assets/minimax-logo.ico'
import gpt4oLogo from '@/assets/gpt4o-logo.svg'
import geminiLogo from '@/assets/gemini-logo.svg'
import veniceLogo from '@/assets/venice-logo.png'
import ollamaLogo from '@/assets/ollama-logo.png'

export const navLinks = [
  { label: 'Workflows', href: '/workflows' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact', href: '/contact' },
];

export const productDropdownLinks = [
  { label: 'Features', href: '/#features', icon: 'spark', subtext: 'Everything Dockclaw offers' },
  { label: 'How it works', href: '/#how-it-works', icon: 'flow', subtext: '3-step Deployment' },
  { label: 'Integration', href: '/integrations', icon: 'plug', subtext: 'Models & Platform' },
  { label: 'Compare', href: '/compare', icon: 'compare', subtext: 'Dockclaw vs alternatives' },
];

export const resourceDropdownLinks = [
  { label: 'Documentations', href: '/docs', icon: 'docs', subtext: 'Setup and API docs' },
  { label: 'Blogs', href: '/blog', icon: 'blog', subtext: 'Updates and deep dives' },
  { label: 'Guides', href: '/guides', icon: 'guide', subtext: 'Step-by-step walkthroughs' },
  { label: 'Use Cases', href: '/use-cases', icon: 'usecase', subtext: 'Explore agent workflows' },
  { label: 'Skill Library', href: '/skills', icon: 'library', subtext: 'Pre-built agent skills' },
  { label: 'Alternatives', href: '/alternatives', icon: 'alt', subtext: 'Compare other options' },
];

export const footerColumns = [
  {
    title: 'Product',
    links: [
      ['Features', '/#features'],
      ['How It Works', '/#how-it-works'],
      ['Pricing', '/pricing'],
      ['Integrations', '/integrations'],
      ['Compare', '/compare'],
    ],
  },
  {
    title: 'Use Cases',
    links: [
      ['Customer Support', '/workflows/customer-support'],
      ['Code Help', '/workflows/code-help'],
      ['Personal Assistant', '/workflows/personal-assistant'],
      ['Ecommerce', '/workflows/ecommerce'],
      ['View All \u2192', '/workflows'],
    ],
  },
  {
    title: 'Resources',
    links: [
      ['Documentation', '/docs'],
      ['Blog', '/blog'],
      ['Guides', '/guides'],
      ['Use Cases', '/use-cases'],
      ['Skills Library', '/skills'],
      ['Alternatives', '/alternatives'],
      ['OpenClaw Docs', 'https://docs.openclaw.ai'],
      ['Support', 'https://t.me/dockclawsupportbot'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['Contact', '/contact'],
      ['Terms & Conditions', '/terms'],
      ['Privacy Policy', '/privacy'],
      ['Impressum', '/impressum'],
    ],
  },
];

export const shelbySupportSteps = [
  {
    title: 'User messages Shelby',
    subtitle: 'Ticket intake',
    accent: 'border-orange/30 bg-orange/12 text-orange',
    delay: '0s',
  },
  {
    title: 'AI analyzes Issue',
    subtitle: 'Customer context',
    accent: 'border-sky-400/30 bg-sky-400/12 text-sky-200',
    delay: '0.18s',
  },
  {
    title: 'Instant Answer or ticket',
    subtitle: 'Internal search',
    accent: 'border-cyan-400/30 bg-cyan-400/12 text-cyan-200',
    delay: '0.36s',
  },
  {
    title: 'Engineering AI Investigates',
    subtitle: 'Task routing',
    accent: 'border-emerald-400/30 bg-emerald-400/12 text-emerald-200',
    delay: '0.54s',
  },
  {
    title: 'Auto-Fix Applied',
    subtitle: 'Draft response',
    accent: 'border-violet-400/30 bg-violet-400/12 text-violet-200',
    delay: '0.72s',
  },
  {
    title: 'User Notified',
    subtitle: 'Human handoff',
    accent: 'border-amber-300/30 bg-amber-300/12 text-amber-200',
    delay: '0.9s',
  },
]

export const shelbyCapabilities = [
  'Support issues & customer questions',
  'Product usage questions',
  'General FAQs',
  'Feature explainability',
  'Billing issues',
  'Technical support',
]

export const configDemo = {
  apiKey: 'sk-ant-api-9K2X7F4LQ8M',
  telegramToken: '7649203811:AAGw9rBotToken',
  yaml: [
    'model: claude-3-7-sonnet',
    'telegram:',
    '  enabled: true',
    '  parse_mode: markdown',
    'runtime:',
    '  file: dockclaw.yaml',
  ],
}

export const agentAssets = {
  claude: {
    src: claudeAgentPaperLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  xai: {
    src: xaiLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  openrouter: {
    src: openrouterLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  groq: {
    src: groqLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  mistral: {
    src: mistralLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  moonshot: {
    src: kimiLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  minimax: {
    src: minimaxLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  gpt4o: {
    src: gpt4oLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  gemini: {
    src: geminiLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  venice: {
    src: veniceLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
  llama: {
  },
  ollama: {
    src: ollamaLogo,
    imgClass: 'h-8 w-8 object-contain',
  },
}
